<div mat-dialog-content>
  <span class="alert alert-danger">There are unsaved changes. Are you sure you want to continue?</span>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="ok()" cdkFocusInitial>OK</button>
  <button mat-button (click)="cancel()">Cancel</button>
</div>
